import { useSessionBootstrap } from '../hooks/use-session-bootstrap'
import type { ReactNode } from 'react'
import { FullPageSpinner } from '@/components/common/FullPageSpinner'

/**
 * Session gate rendered above the router. On first load it either consumes a
 * JWT handed off via the URL hash (`/#token=<jwt>`) or restores the session
 * from a persisted token by re-fetching `/auth/me`. In both cases it shows a
 * spinner until the session is resolved, so the store is populated before any
 * route guard runs. With no token at all it renders children immediately.
 */
export function AuthTokenBootstrap({ children }: { children: ReactNode }) {
  const status = useSessionBootstrap()

  if (status === 'pending') return <FullPageSpinner />
  return <>{children}</>
}
